import React from "react";
import { PLAY_STORE_BADGE_HI } from "./utm";
import play_store_qr from "../../assets/play_store_qr.png";

export default function PlayStoreCTA({
  href,
  badgeClassName = "h-12 sm:h-14",
  qrSize = "w-20 h-20",
  className = "",
}) {
  return (
    <div className={`flex items-center gap-3 sm:gap-4 ${className}`}>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block"
      >
        <img
          src={PLAY_STORE_BADGE_HI}
          alt="Google Play से Pathyacharya डाउनलोड करें"
          className={badgeClassName}
        />
      </a>
      <div className="hidden md:flex flex-col items-center">
        <img
          src={play_store_qr}
          alt="Play Store QR code — स्कैन करके Pathyacharya install करें"
          className={`${qrSize} rounded-md border border-gray-200 bg-white p-1.5 shadow-sm`}
        />
        <span className="text-[10px] text-gray-500 mt-1 whitespace-nowrap">
          📱 स्कैन करें
        </span>
      </div>
    </div>
  );
}
